import { reactive } from 'vue'
import type { ToastItem } from './types'

let id = 0
const toasts: ToastItem[] = reactive([])

export function useToastrStore() {
    function show(message: string, type: ToastItem['type'], duration = 5000) {
        const toast: ToastItem = { id: ++id, message, type }
        toasts.push(toast)
        setTimeout(() => remove(toast.id), duration)
    }

    function showUntilClosed(message: string, type: ToastItem['type']) {
        const toast: ToastItem = { id: ++id, message, type }
        toasts.push(toast)
    }

    function remove(toastId: number) {
        const i = toasts.findIndex(t => t.id === toastId)
        if (i !== -1) toasts.splice(i, 1)
    }

    return {
        toasts,
        showUntilClosed,
        remove,
        show,
    }
}
